import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import { SegmentedTabNavItems } from '../../../constants/routing/NavItems';
import { usePageParams } from '../../../hooks/usePageParams';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import SegmentedTabs from './SegmentedTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SegmentedTabsLayout = ({
  isIntersecting = false,
  selectedNavItem
}) => {
  const isAppAuth = useSelector(isAppAuthSelector);
  const hideTabs = isAppAuth || !SegmentedTabNavItems.includes(selectedNavItem);
  const {
    tab
  } = usePageParams();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !hideTabs && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(SegmentedTabs, {
        bordered: !hideTabs && isIntersecting,
        selectedTab: tab,
        path: `/${selectedNavItem}`
      })
    })
  });
};
export default SegmentedTabsLayout;